import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "relative w-full" }
const _hoisted_3 = { class: "absolute bottom-full right-0 z-10 mb-4 space-x-4" }
const _hoisted_4 = {
  key: 0,
  class: "relative z-30 mt-4 flex w-full items-center justify-end space-x-2"
}

import { computed, ref } from "vue";

import { Image } from "~/js/interfaces/media";

import { getClasses } from "~/js/composables/classes";
import { getGlobalTranslation } from "~/js/composables/translations";

import Body from "~/vue/atoms/texts/TextBody.vue";
import ButtonPrimary from "~/vue/atoms/buttons/ButtonPrimary.vue";
import ImageGallery from "~/vue/atoms/images/ImageGallery.vue";

interface Options {
	showPrev: boolean;
	showNext: boolean;
	showButtons: boolean;
}

interface Props {
	image: Image;
	ratio?: string;
	sizes?: Array<string>;
	utilities?: string;
	options?: Options;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LightboxImage',
  props: {
    image: {},
    ratio: { default: "" },
    sizes: {},
    utilities: { default: "" },
    options: { default: {
		showPrev: false,
		showNext: false,
		showButtons: false,
	} }
  },
  emits: ["hide", "prev", "next"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const classes = ref({
	wrapper: {
		flex: "flex flex-col items-end",
	},
	overlay: {
		position: "fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 bg-black/85",
		size: "w-screen h-screen",
	},
	image: {
		object: "rounded-3xl",
		position: "relative z-20",
		size: "w-full h-auto",
	},
});

const sizes = computed(() => {
	if (props.sizes) {
		return props.sizes.join(",");
	}

	return "100vw";
});

const onHide = () => {
	emit("hide");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.utilities, _unref(getClasses)(classes.value, 'wrapper')])
  }, [
    _createElementVNode("div", {
      role: "button",
      "aria-label": _unref(getGlobalTranslation)('Close'),
      class: _normalizeClass(_unref(getClasses)(classes.value, 'overlay')),
      onClick: onHide
    }, null, 10, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Body, { color: "text-white" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getGlobalTranslation)("Press ESC to close")), 1)
          ]),
          _: 1
        }),
        _createVNode(ButtonPrimary, {
          ga: { category: 'popup-hide', action: 'click', label: _unref(getGlobalTranslation)('Close') },
          icon: "times",
          size: "small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('hide')))
        }, null, 8, ["ga"])
      ]),
      _createVNode(ImageGallery, {
        image: __props.image,
        ratio: __props.ratio,
        utilities: _unref(getClasses)(classes.value, 'image')
      }, null, 8, ["image", "ratio", "utilities"]),
      ((__props.options.showPrev || __props.options.showNext) && __props.options.showButtons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(ButtonPrimary, {
              ga: { category: 'popup-prev', action: 'click', label: _unref(getGlobalTranslation)('Previous') },
              icon: "chevron-left",
              size: "small",
              disabled: !__props.options.showPrev,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('prev')))
            }, null, 8, ["ga", "disabled"]),
            _createVNode(ButtonPrimary, {
              ga: { category: 'popup-prev', action: 'click', label: _unref(getGlobalTranslation)('Next') },
              icon: "chevron-right",
              size: "small",
              disabled: !__props.options.showNext,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('next')))
            }, null, 8, ["ga", "disabled"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})